export const SectionRouter = {
    methods: {
        routeSectionLink(section) {
            if (section.sublevels_count > 1) {
                this.$root.title = this.$root.getLangText(section.title);
                this.$router.push({
                    path: '/sections/' + section.id,
                    props: {
                        parentSection: section,
                    }
                });
                return false;
            }

            if (section.external_link) {
                window.open(section.external_link, '_blank');
                return false;
            }

            this.$root.title = section.title;
            this.$router.push({path: '/products/' + section.id});
        }
    },
};

